import { AxiosClient } from '@pole/client/agromarket'
import { CanceledError } from 'axios'
import { reduxStore } from '@/api/client/base'
import { getJwt } from '@/logic/auth/reducer'
import { ExecutionEnvironment } from '@/utils/ExecutionEnvironment'

const { isSsr } = ExecutionEnvironment
const { NODE_ENV } = process.env
const IS_DEV = NODE_ENV !== 'production'

const ssrUrl =
  isSsr && IS_DEV
    ? `http://${process.env.CUSTOM_ENV}-ms-core-signature-backend.dev.poletech.io/api`
    : `http://ms-core-signature-backend/api`
const baseURL = isSsr ? ssrUrl : '/api/ms-core-signature-backend'

export const registerLibCoreSignatureApiAxiosClient = () => {
  AxiosClient.registerApi('lib-core-signature-api', { baseURL, timeout: Number(process.env.API_RESPONSE_TIMEOUT) || 60_000 })
}

export const libCoreSignatureApiAxiosClient = AxiosClient.getClient({
  apiName: 'lib-core-signature-api',
  onRequest: config => {
    if (!reduxStore.store) return config

    const reduxToken = getJwt()(reduxStore.store?.getState?.())
    if (!config.headers.Authorization && !!reduxToken?.length) config.headers.Authorization = `Bearer ${reduxToken}`

    return config
  },
})

export * from './types'
export { CanceledError }
export default libCoreSignatureApiAxiosClient
